<template>
  <div style="display:flex; background-color:rgb(255,159,159)">
    <div
      class="p-1 column65 text-center text-bold border-top border-left border-right border-dark "
    >
      SUBTOTAL
    </div>
    <div
      class="p-1 column15 text-center text-bold border-top border-right border-dark"
    >
      {{ subtotal }}
    </div>
    <div
      class="p-1 border-right border-top border-dark"
      style="height: auto;width:20%"
    ></div>
  </div>
</template>
<script>
export default {
  props: ['subtotal'],
}
</script>
